import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./styles/global.css";

// Handle Vite preload errors (e.g., when old assets are deleted after deployment)
// This ensures users get the latest version instead of seeing a blank page
window.addEventListener("vite:preloadError", () => {
  console.warn(
    "Vite preload error detected, reloading page to fetch latest assets...",
  );
  window.location.reload();
});

const container = document.getElementById("root")!;

// Prerendered pages (see scripts/prerender.ts) ship real markup inside #root so
// crawlers and JS-less clients get full content. We deliberately client-render
// rather than hydrate: the snapshots are serialized from the live DOM, which
// drops the `<!-- -->` separators React needs between adjacent text nodes, so
// hydrateRoot mismatches on every route and falls back to a full re-render with
// console errors. createRoot gets the same result predictably and quietly.
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

